<template>
    <div class="dispatch">
        <router-view />
    </div>
</template>

<script>
export default {
	name: "Dispatch"
};
</script>

<style lang="scss" scoped>
@import 'dispatch';
</style>
